import { useEffect, useState } from "react";
import { getSiteSettings, getSiteHero, getSiteAbout, getSiteServices, getSiteGallery, getSiteNav } from "../lib/api";

const cache = {};

const useSiteResource = (key, fetcher) => {
  const [data, setData] = useState(cache[key] || null);

  useEffect(() => {
    if (cache[key]) {
      setData(cache[key]);
      return;
    }
    let active = true;
    fetcher()
      .then((d) => {
        cache[key] = d;
        if (active) setData(d);
      })
      .catch(() => {
        if (active) setData(false);
      });
    return () => {
      active = false;
    };
  }, [key, fetcher]);

  return data;
};

export const useSiteSettings = () => useSiteResource("settings", getSiteSettings);
export const useSiteHero = () => useSiteResource("hero", getSiteHero);
export const useSiteAbout = () => useSiteResource("about", getSiteAbout);
export const useSiteServices = () => useSiteResource("services", getSiteServices);
export const useSiteGallery = () => useSiteResource("gallery", getSiteGallery);
export const useSiteNav = () => useSiteResource("nav", getSiteNav);
